<template>
  <div class="container mb-3">
      <div class="row">
        <p class="data-row col p-2 m-0 bg-primary text-uppercase">
          <strong>{{name}}</strong><br>
        </p>
      </div>
      <div class="row">
        <p class="data-row col border p-2 m-0">
          <strong>{{ $t("dateInfo.from") }}:</strong><br>
          {{from || $t("dateInfo.airport") }}
        </p>
      </div>
      <div class="row">
        <p class="data-row col border p-2 m-0">
          <strong>{{ $t("dateInfo.to") }}:</strong><br>
          {{to || $t("dateInfo.airport") }}
        </p>
      </div>
      <div class="row">
        <p class="data-row col border p-2 m-0">
          <strong><span v-if="!placeToPlace">{{ $t("dateInfo.flightDate") }}:</span> <span v-else> {{ $t("dateInfo.date") }}: </span> </strong><br>
          {{formateDate(date)}}
          <!-- {{formateTime(date, hours, minutes)}} -->
        </p>
        <p class="data-row col border p-2 m-0">
          <strong><span v-if="!placeToPlace">{{ $t("dateInfo.flightTime") }}:</span> <span v-else> {{ $t("dateInfo.time") }}: </span> </strong><br>
          {{formateTime(hours,minutes)}}
        </p>
      </div>
      <div v-if="pickUp" class="row">
        <p class="data-row col border p-2 m-0">
          <strong>{{ $t("dateInfo.pickUpDate") }}:</strong><br>
          {{formateDate(formDates.pickUpDate)}}
        </p>
        <p class="data-row col border p-2 m-0">
          <strong>{{ $t("dateInfo.pickUpTime") }}:</strong><br>
          {{formateTime(formDates.pickUpHours,formDates.pickUpMinutes)}}
        </p>
      </div>
      <div v-if="!placeToPlace" class="row">
        <p class="data-row col border p-2 m-0">
          <strong>{{ $t("dateInfo.flight") }}:</strong><br>
          {{flight}}
        </p>
        <p class="data-row col border p-2 m-0">
          <strong>{{ $t("dateInfo.airline") }}:</strong><br>
          {{airline}}
        </p>
      </div>
      <div v-if="extras" class="row">
        <p class="data-row col border p-2 m-0">
          <strong>{{ $t("dateInfo.extras") }}:</strong><br>
          <span v-for="extra in extras">
            {{extra.name+'('+extra.quantity+')'}}
          </span>
        </p>
      </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Utils from '../js/Utils'
import moment from 'moment'

export default {
  name: 'DateInformation',
  components: {
  },
  props: {
    name: String,
    from: String,
    to: String,
    date: Date,
    hours: Number,
    minutes: Number,
    pickUp: Boolean,
    placeToPlace: Boolean,
    flight: String,
    airline: String,
    extras: Array
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(['form', 'formDates'])
  },
  methods: {
    formateTime(hours, minutes) {
      let formate = Utils.formateTime(hours, minutes)
      return `${formate} hrs`;
    },
    formateDate(date) {
      return moment(date).format("D MMM YYYY")
    }
  },
  mounted () {
  }
}
</script>
